(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["snapmount-anleitung"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var chapters = document.getElementById('se-chapters');
    if (chapters) {
      chapters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-t]');
        if (!btn) return;
        var v = document.getElementById('se-video');
        if (!v) return;
        v.currentTime = Number(btn.getAttribute('data-t'));
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    document.querySelectorAll('.se-guide-accordion__item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.se-guide-accordion__item').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.nextElementSibling.classList.remove('is-open');
          b.nextElementSibling.removeAttribute('data-open');
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
